// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__q_IP3","waveAnimation":"Skeleton_waveAnimation__2Wz9h"};